import objectToQueryParams from 'helpers/objectToQueryParams'

const urlGenerator = ({ name, message, url }) => {
  let link = url
  switch (name) {
    default:
      link = url
      break
    case 'linkedin':
      link = `https://www.linkedin.com/sharing/share-offsite/${objectToQueryParams({ url })}`
      break
    case 'twitter':
      link = `https://twitter.com/share/${objectToQueryParams({ url, text: message, via: 'GetApp' })}`
      break
    case 'facebook':
      link = `https://www.facebook.com/sharer/sharer.php/${objectToQueryParams({ u: url, quote: message })}`
      break
  }

  return link
}

export default urlGenerator
